import { render, staticRenderFns } from "./UpcomingPropertiesBanner.vue?vue&type=template&id=d58c049c"
var script = {}
import style0 from "./UpcomingPropertiesBanner.vue?vue&type=style&index=0&id=d58c049c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports